import { render, staticRenderFns } from "./ViewReservationsPreordersDialog.vue?vue&type=template&id=7c3e74ae&lang=pug&"
import script from "./ViewReservationsPreordersDialog.vue?vue&type=script&lang=js&"
export * from "./ViewReservationsPreordersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports